import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DigitSymbolShape = _resolveComponent("DigitSymbolShape");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapping-legend", {
      'mapping-legend--compact': $props.compact
    }]),
    "aria-label": "数字图形对应关系"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.mapping, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.digit,
      class: "mapping-item"
    }, [_createVNode(_component_DigitSymbolShape, {
      "shape-id": item.shapeId,
      size: $props.compact ? 38 : 42
    }, null, 8, ["shape-id", "size"]), _createElementVNode("strong", null, _toDisplayString(item.digit), 1)]);
  }), 128))], 2);
}